import type { GetLastSavedSearchResponse } from "@/modules/jobAds/client/api/types"

import { useQuery } from "@tanstack/react-query"

import { GET_USER_MONO_SAVED_SEARCH_QUERY_KEY } from "@/modules/jobAds/client/api/constants"
import { getUserSavedSearch } from "@/modules/jobAds/client/api/getUserSavedSearch"

type GetUserSavedSearch = {
  data: GetLastSavedSearchResponse
  isSuccess: boolean
  isLoading: boolean
  isError: boolean
}

type UseGetUserSavedSearchParams = {
  isUserLogged: boolean
}

export const useGetUserSavedSearch = ({ isUserLogged }: UseGetUserSavedSearchParams): GetUserSavedSearch => {
  const {
    data,
    isPending: isLoading,
    isError,
    isSuccess,
  } = useQuery<GetLastSavedSearchResponse, Error>({
    enabled: isUserLogged,
    queryFn: () => getUserSavedSearch(),
    queryKey: [GET_USER_MONO_SAVED_SEARCH_QUERY_KEY],
  })

  return {
    data: data || null,
    isError,
    isLoading,
    isSuccess,
  }
}
